import angular from 'angular';

/* Configuration Imports */
import MaintenanceRouteConfig from './maintenance.route';
/* Controller Imports */
import MaintenanceController from './maintenance.controller';

/* Module Imports */
import MaintenancePlansModule from './plans/plans.module';
import MaintenanceHistoryModule from './history/history.module';
import MaintenanceBoardModule from './board/board.module';
const maintenanceModule = angular.module('app.maintenance', [
  //INTERNAL
  MaintenancePlansModule,
  MaintenanceHistoryModule,
  MaintenanceBoardModule,
  //THIRD PARTY
  'ui.router',
  'ui.bootstrap',
  'ncy-angular-breadcrumb',
  'gettext'
]);

maintenanceModule
  /* Configurations */
  .config(MaintenanceRouteConfig)
  /* Controllers */
  .controller('MaintenanceController', MaintenanceController);

export default maintenanceModule.name;
